@use "Styles/includes/variables";
@use "Styles/mixins";

@keyframes modal-slide-in {
    from {
        opacity: 0;
        transform: translateY(-16px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes modal-slide-out {
    from {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    to {
        opacity: 0;
        transform: translateY(-16px) scale(0.97);
    }
}

:host {
    display: contents;
}

.vm-modal {
    border: none;
    border-radius: 24px;
    padding: 0;
    max-width: 650px;
    width: calc(100% - 32px);
    max-height: calc(100dvh - 64px);
    overflow: var(--vm-modal-overflow, auto);
    background: mixins.get-color(bg, solid, primary);
    box-shadow:
        -2px -12px 48px -12px rgba(10, 13, 18, 0.18),
        4px -8px 4px -2px rgba(10, 13, 18, 0.04);
    animation: modal-slide-in 0.2s ease-out;

    &::backdrop {
        @include mixins.overlay-backdrop;
    }

    &--closing {
        animation: modal-slide-out 0.2s ease-in forwards;

        &::backdrop {
            @include mixins.overlay-backdrop-closing;
        }
    }

    &__container {
        display: flex;
        flex-direction: column;
        max-height: calc(100dvh - 64px);
        padding: 8px 0 24px;

        // When a footer is slotted in, drop the container's bottom padding so the
        // footer sits flush against the dialog's bottom edge.
        &:has(.vm-modal__footer:not(.vm-modal__footer--empty)) {
            padding-bottom: 0;
        }
    }

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        height: 24px;
        padding: 8px 16px;
        flex-shrink: 0;
    }

    &__header-content {
        flex: 1;
        min-width: 0;
    }

    &__close-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        padding: 4px;
        cursor: pointer;
        border-radius: 4px;
        color: mixins.get-color(text, text-tertiary);
        flex-shrink: 0;
    }

    &__body {
        padding: 16px 32px;
        overflow-y: auto;
        flex: 1;
        min-height: 0;
    }

    &__title {
        margin: 0 0 24px;
        font-family: variables.$fontQuaternary;
        font-size: 20px;
        line-height: 30px;
        font-weight: 900;
        color: mixins.get-color(text, text-primary);
    }

    // Sticky footer area pinned below the scrollable body. Hidden when nothing is
    // slotted in (driven by slotchange in vm-modal.ts), so consumers that don't use
    // the footer get no visual change.
    &__footer {
        flex-shrink: 0;
        padding: 16px 32px;
        background: mixins.get-color(bg, solid, primary);
        box-shadow:
            0 -4px 3px rgba(10, 13, 18, 0.03),
            0 -2px 1px rgba(10, 13, 18, 0.04);

        &--empty {
            display: none;
        }
    }
}
